<template>
  <div class="about-page">
    <div class="main-content">
      <!-- 第一部分：英雄区域 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          
          <div class="hero-content">
            <h1 class="hero-title animate">走进闻讼</h1>
            <h2 class="hero-subtitle animate">更多的了解我们</h2>
          </div>
        </div>
      </section>
      
      <!-- 第二部分：公司简介 -->
      <section class="intro-section" ref="introSection">
        <div class="container">
          <h2 class="section-title animate-scroll">闻讼简介</h2>
          
          <div class="intro-content">
            <div class="intro-text animate-scroll">
              <p>闻讼公司成立于2022年末，孵化于中国法律科技领域的领先企业，秉承深厚的法律行业基因与创新服务理念，致力于为企业提供一体化法律风险解决方案。我们通过精准管理诉讼争议案件需求与全流程运营，高效连接全国范围内的优质律师资源，确保每一件法律争议都能匹配最合适的专业律师，实现高效、精准的解决。</p>
              <p>"闻讼"之名，源自孔子《论语·颜渊》中"听讼，吾犹人也，必也使无讼乎"的智慧。我们深知，诉讼并非终点，化解矛盾、减少争端才是法律的更高追求。闻讼以专业之力深入争议本源，通过精准服务与前瞻性洞察，助力企业降低诉讼风险、减少同类纠纷，为"无讼"的理想贡献实践力量。</p>
              <p>目前，闻讼已获得阿里巴巴、京东等众多头部企业的认可与信赖。未来，我们将继续以专业为基、以创新为翼，陪伴企业行稳致远，让法律成为商业发展的护航者。</p>
              <p>懂法律，更懂企业；解争议，更求无讼。</p>
            </div>
            
            <div class="intro-image animate-scroll">
              <img src="@/assets/image/group1@2x.png" alt="闻讼">
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'AboutPage',
  components: {
    AppFooter,
    AppHeader
  },
  data() {
    return {
      observers: []
    }
  },
  mounted() {
    this.initScrollAnimations();
    
    // 首屏动画自动播放
    const animateElements = document.querySelectorAll('.animate');
    animateElements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('visible');
      }, 300 * index);
    });
    // 头部动画
    this.$nextTick(() => {
      const header = this.$el.querySelector('.logo-area.animate-scroll');
      if (header) header.classList.add('visible');
    });
  },
  beforeUnmount() {
    // 清除所有观察者
    this.observers.forEach(observer => observer.disconnect());
  },
  methods: {
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      const sections = [
        this.$refs.introSection
      ];
      
      sections.forEach(section => {
        if (section) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const animatedElements = entry.target.querySelectorAll('.animate-scroll');
                animatedElements.forEach(el => {
                  el.classList.add('visible');
                });
              }
            });
          }, options);
          
          observer.observe(section);
          this.observers.push(observer);
        }
      });
    }
  }
}
</script>

<style scoped>
.about-page {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  width: 1920px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.footer-wrapper {
  flex-shrink: 0;
}

/* 入场动画基础样式 */
.animate, .animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate.visible, .animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 英雄区域样式 */
.hero-section {
  width: 1920px;
  height: 600px;
  background-image: url('~@/assets/image/zjws.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 302px;
  padding-left: 2px;
}

.hero-title {
  font-weight: 600;
  font-size: 40px;
  color: #FFFFFF;
  margin: 0;
  line-height: 56px;
}

.hero-subtitle {
  font-weight: 400;
  font-size: 26px;
  color: #FFFFFF;
  margin-top: 10px;
  line-height: 37px;
}

/* 公司简介部分样式 */
.intro-section {
  width: 1920px;
  background: #FFFFFF;
  padding: 40px 0;
  position: relative;
  min-height: 842px;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 40px;
  line-height: 50px;
}

.intro-content {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.intro-text {
  width: 585px;
  font-size: 24px;
  color: #333333;
  line-height: 33px;
}

.intro-text p {
  margin-bottom: 33px;
}

.intro-image {
  width: 420px;
  height: 306px;
}

.intro-image img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
}
</style> 